var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#192235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1621 11.6667H17.4954C13.3288 11.6667 11.6621 13.3334 11.6621 17.5001V22.5001C11.6621 26.6667 13.3288 28.3334 17.4954 28.3334H22.4954C26.6621 28.3334 28.3288 26.6667 28.3288 22.5001V20.8334",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3714 12.5166L16.8048 19.0833C16.5548 19.3333 16.3048 19.825 16.2548 20.1833L15.8964 22.6916C15.7631 23.6 16.4048 24.2333 17.3131 24.1083L19.8214 23.75C20.1714 23.7 20.6631 23.45 20.9214 23.2L27.4881 16.6333C28.6214 15.5 29.1548 14.1833 27.4881 12.5166C25.8214 10.85 24.5048 11.3833 23.3714 12.5166Z",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4258 13.4585C22.9841 15.4502 24.5424 17.0085 26.5424 17.5752",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.ab53b4c32d22ec01e292b188ac557b6b.svg";
export { ForwardRef as ReactComponent };